import { FC } from 'react'
import { Country } from '../../../../types'
import { useHrSupportStore } from '../HrSupportStore'
import shallow from 'zustand/shallow'
import { HrSupportHRBPInfoBox } from './HrSupportHRBPInfoBox'
import { HrSupportHRBPTable } from './HrSupportHRBPTable'
import {
  useActiveHrBusinessPartnersByCountry,
  usePossibleCompaniesForCreateNewHRBusinessPartner,
} from '../../../../graphql/hrBusinessPartners/QueryFunctions'
import { LoadingAndErrors } from '../../../../components/custom_components/LoadingAndErrors'

export const HrSupportHRBPTab: FC = () => {
  const [selected] = useHrSupportStore((state) => [state.selected, state.feedbackTabFilters], shallow)
  const country = selected.value as Country

  const { data, error, loading } = useActiveHrBusinessPartnersByCountry(country)
  const {
    data: possibleCompaniesData,
    error: possibleCompaniesError,
    loading: possibleCompaniesLoading,
  } = usePossibleCompaniesForCreateNewHRBusinessPartner()

  if (
    loading ||
    error ||
    !data ||
    !data.getHrBusinessPartnersByCountry ||
    possibleCompaniesLoading ||
    possibleCompaniesError ||
    !possibleCompaniesData ||
    !possibleCompaniesData.getPossibleCompaniesForCreateNewHrBusinessPartner
  ) {
    return (
      <LoadingAndErrors
        isLoading={loading || possibleCompaniesLoading}
        hasNoData={
          !data ||
          !data.getHrBusinessPartnersByCountry ||
          !possibleCompaniesData ||
          !possibleCompaniesData.getPossibleCompaniesForCreateNewHrBusinessPartner
        }
        error={error || possibleCompaniesError}
        showSpinner
      />
    )
  }

  const businessPartnerRelations = data.getHrBusinessPartnersByCountry
  const possibleCompanies = possibleCompaniesData.getPossibleCompaniesForCreateNewHrBusinessPartner
  return (
    <>
      <HrSupportHRBPInfoBox
        numberOfRelations={businessPartnerRelations.length}
        initialPossibleCompanies={possibleCompanies}
        country={country}
        businessPartnerRelations={businessPartnerRelations}
      />
      <HrSupportHRBPTable hrbpList={businessPartnerRelations} />
    </>
  )
}
